/**
 * Copyright IBM Corp. 2022, 2026
 */

import { MDSButton } from '@hashicorp/mds-react/components'
import s from './style.module.css'

export default function ButtonBlock({ text, url, linkType }) {
	return (
		<div className={s.buttonBlock}>
			<MDSButton title={text} url={url} linkType={linkType} />
		</div>
	)
}
